'use strict';

module.exports = {
    init: function (config) {
        this.subscribePageLogin = config.premiumExperience && config.premiumExperience.subscribePageLogin;
        this.customSubscribeUrl = config.exclusiveContent && config.exclusiveContent.subscribeUrl;
    },
};
